/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .mat-checkbox-layout[_ngcontent-%COMP%]{white-space:normal!important}[_nghost-%COMP%]     .mat-checkbox-label{font-weight:300!important;width:98%;white-space:normal!important;word-wrap:break-word}"];
export { styles as styles };
